import {type ReactNode} from 'react'
// Components
import BoundLink from '../bound-link'
// Layout
import Section from './section'
// Styles
import pageStyles from './page.module.scss'

interface PageSimplePageProps {
  title: string
  isErrorPage?: boolean
  children?: ReactNode
}

const PageSimplePage = ({
  title,
  isErrorPage = false,
  children = null,
}: PageSimplePageProps) => {
  return (
    <div className={pageStyles['page']}>
      <Section
        styleModifiers={[
          '--is-main',
          '--is-flex-column',
          '--is-full-height',
          '--is-centered',
        ]}
      >
        <h1 style={{
          fontSize: '2em',
          whiteSpace: 'pre-wrap',
        }}>
          {title}
        </h1>
        {children}
        {isErrorPage && <>
          <h2 className='title is-4 pb-2'>
            Please return to the home page
          </h2>
          <BoundLink
            href='/'
            className='button is-large is-dark'
          >
            OK
          </BoundLink>
        </>}
      </Section>
    </div>
  )
}

export default PageSimplePage
